import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateMultipleChoiceContent } from "./logic/content";

export const MODULE_TYPE = "multiple-choice";
export type TYPE = "multiple-choice";
export { transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateMultipleChoiceContent)
    .getModuleAssets(getModuleAssets)
    .back.staticInformation()
    .displayName("Multiple Choice")
    .testOnly()
    .supportsAmeliaExplainMyAnswer()
    .root.register();
